import { useTranslation } from 'react-i18next';
import { useFetchPropertiesFilterOptions } from 'components/domain/property/useFetchPropertiesFilterOptions';
import MultiSelectField, {
  MultiSelectFieldProps,
} from 'components/forms/multiSelectField/MultiSelectField';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { PropertiesFilterOptions } from 'models/PropertiesFilter';
import { normalizeKey } from 'utils/localeUtils';

interface TagsMultiSelectFieldProps
  extends Omit<MultiSelectFieldProps, 'fieldRenderer' | 'options'> {
  filterOptions?: PropertiesFilterOptions;
  propertyUids?: string[];
  labelKey?: string;
}

const TagsMultiSelectField = ({
  propertyUids,
  labelKey,
  filterOptions: filterOptionsProp,
  ...rest
}: TagsMultiSelectFieldProps) => {
  const { t } = useTranslation();
  const { data, isLoading } = useFetchPropertiesFilterOptions({
    enabled: !filterOptionsProp || (propertyUids && propertyUids.length > 0),
    propertyUids,
  });
  const filterOptions = filterOptionsProp ?? data;
  const tags = filterOptions?.propertyTagNames
    .sort((tag1, tag2) => tag1.localeCompare(tag2))
    .map((tag) => ({
      label: tag,
      value: tag,
    }));

  if (isLoading) return <LoadingPlaceholder />;

  return (
    <MultiSelectField
      colSmInput={8}
      colSmLabel={4}
      label={t(labelKey ? normalizeKey(labelKey) : 'pageCalendar.stacked.tags')}
      // @ts-expect-error TS2783 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      name="tags"
      options={tags}
      {...rest}
    />
  );
};

TagsMultiSelectField.defaultProps = {
  filterOptions: undefined,
  propertyUids: undefined,
  labelKey: 'pageCalendar.stacked.tags',
};

export default TagsMultiSelectField;
